<div class="item-image" [class.item-image--has-img]="!!background">
    @if (background) {
        <img class="item-background" disableOptimizedSrcset fill [priority]="priority" [ngSrc]="background" />
    }
    <div class="icon-title">
        @if (story.icon) {
            <div class="item-icon">
                <span><i [ngClass]="story.icon"></i></span>
            </div>
        }
        @if (stretch) {
            <div title="{{ story.title }}" class="item-title">{{ story.title }}</div>
        }
    </div>
    @if (stretch) {
        <button class="item-button btn btn-primary" (click)="openStory($event)"><i class="theme-play-solid"></i>{{ more }}</button>
    }
</div>
@if (!stretch) {
    <div title="{{ story.title }}" class="item-title">{{ story.title }}</div>
}
